// extracted by mini-css-extract-plugin
export default {"cls1":"CoreXNav-cls1___2d306e1a26999f8c390","cls2":"CoreXNav-cls2___656d93659d877de7dca CoreXNav-cls1___2d306e1a26999f8c390"};